import styled, { css } from 'styled-components'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import { surfaces } from '../../theme'

// Constantes
export const BUTTON_HEIGHT = 220
export const VIDEO_EXPANDED_WIDTH = 700
export const VIDEO_MIN_WIDTH = Math.round((BUTTON_HEIGHT * 16) / 9)
export const BUTTON_SIZE = 220
export const BUTTON_RADIUS = 12
export const ICON_CIRCLE_SIZE = 48
export const ICON_SIZE = 24

// Estilos globales para el contenedor raíz
export const GlobalContainer = styled.div`
  position: absolute;
  top: 64px; /* Altura de la topbar */
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(100vh - 64px); /* Altura exacta del espacio disponible */
  display: flex;
  flex-direction: column;
  z-index: 0;
`

export const CarouselWrapper = styled.div`
  width: 100%;
  margin: 40px auto -40px auto;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 40px;
  /* The carousel's loading and empty-state lines sit on the dark page. */
  color: ${themeColors.whiteTransparent06};
`

export const ScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;

  /* Estilos del scrollbar para Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.5) transparent;

  /* Estilos del scrollbar para Chrome, Safari y Edge */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.7);
  }
`

export const CropMasterPageWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  padding: 34px 0 64px;
`

export const WelcomeTextWrapper = styled.div`
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 0 64px 0 64px;
  width: 100%;
  text-align: center;
  @media (min-width: 900px) {
    width: 50%;
    text-align: left;
    align-items: flex-start;
    padding: 0 64px 0 0;
  }
  @media (max-width: 500px) {
    padding: 0;
  }
`

export const WelcomeText = styled.div`
  color: #fff;
  font-size: 16px;
  font-weight: 300;
  max-width: initial;
  margin-bottom: 16px;
  padding-top: ${({ hasScroll }) => (hasScroll ? '80px' : '0')};
  @media (max-width: 700px) {
    padding: ${({ hasScroll }) => (hasScroll ? '60px 20px 0' : '0 20px')};
    margin: 0 auto;
    max-width: 700px;
  }
`

export const CenteredRowWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
`

export const RowWithVideo = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 900px) {
    width: 50%;
    justify-content: flex-end;
    margin-left: 0;
    margin-right: 0;
  }
`

export const TopButton = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ bgimg }) => `url(${bgimg}) center center/cover no-repeat`};
  border-radius: ${BUTTON_RADIUS}px;
  width: 100%;
  max-width: ${BUTTON_SIZE}px;
  height: ${BUTTON_SIZE}px;
  text-decoration: none;
  box-shadow: ${surfaces.floatingPanelShadow};
  transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  padding: 0;
  overflow: hidden;
  border: 1px solid ${themeColors.mintBorder};

  &:hover {
    border-color: ${themeColors.mintColor};
  }

  @media (max-width: 700px) {
    max-width: 140px;
    height: 140px;
  }
`

export const TopButtonOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 33%, rgba(0, 0, 0, 0.7) 100%);
  z-index: 1;
  transition: background 0.2s;

  ${TopButton}:hover & {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 33%, rgba(0, 0, 0, 0.35) 100%);
  }
`

export const TopButtonIcon = styled.img`
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  object-fit: contain;
  display: block;
  margin: 0;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.25));
`

export const VideoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  border-radius: ${BUTTON_RADIUS}px;
  overflow: hidden;
  box-shadow: ${surfaces.floatingPanelShadow};
  transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.5s cubic-bezier(0.4, 2, 0.6, 1),
    height 0.5s cubic-bezier(0.4, 2, 0.6, 1);
  min-width: ${VIDEO_MIN_WIDTH}px;
  border: 1px solid ${themeColors.mintBorder};

  ${({ isPlaying }) =>
    isPlaying
      ? css`
          width: ${VIDEO_EXPANDED_WIDTH}px;
          max-width: 60vw;
          height: calc(${VIDEO_EXPANDED_WIDTH}px * 9 / 16);
          max-height: 60vh;
          box-shadow: 0 6px 24px rgba(0, 0, 0, 0.4);
          aspect-ratio: 16 / 9;
        `
      : css`
          width: 100%;
          max-width: ${VIDEO_MIN_WIDTH}px;
          height: ${BUTTON_HEIGHT}px;

          &:hover {
            border-color: ${themeColors.mintColor};
          }
        `}// @media (max-width: 700px) {
  //   width: 100% !important;
  //   max-width: 200px;
  //   min-width: 120px;
  //   height: 140px !important;
  //   aspect-ratio: unset;
  // }
`

export const PlayOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 33%, rgba(0, 0, 0, 0.5) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  transition: background 0.2s;

  &:hover {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 33%, rgba(0, 0, 0, 0.35) 100%);
  }
`

// The video's main action, mint like the confirm buttons: it takes their mint ring while the
// pointer is over the video.
export const PlayButton = styled.div`
  width: 56px;
  height: 56px;
  background: ${themeColors.mintColor};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  font-size: 32px;
  color: ${themeColors.deepblueColor3};
  transition: box-shadow 0.15s;

  ${PlayOverlay}:hover & {
    box-shadow: 0 0 0 3px ${themeColors.mintColorTransparent}, 0 2px 8px rgba(0, 0, 0, 0.18);
  }
`

export const IconCircle = styled.div`
  width: ${ICON_CIRCLE_SIZE}px;
  height: ${ICON_CIRCLE_SIZE}px;
  background: ${themeColors.mintColor};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`

export const ButtonLabel = styled.div`
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 24px;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  padding: 0 8px;
`

export const TopButtonLink = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  width: ${BUTTON_SIZE}px;
  grid-area: ${({ area }) => area};

  @media (max-width: 1000px) {
    width: 180px;
  }

  @media (max-width: 700px) {
    width: 140px;
  }
`

export const CropMasterLogo = styled.img`
  max-width: 320px;
  display: block;
  margin: 0 auto 32px;
`

export const ContentCenterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
  gap: 32px;
  margin-bottom: 32px;
  justify-content: center;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

export const ButtonsWrapper = styled.div`
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  gap: 30px;
`

export const VideoCloseOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 5;
  background: transparent;
`

export const VideoModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 20px;
`

export const VideoModalWrapper = styled.div`
  position: relative;
  margin: auto;
  z-index: 7;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  width: 100%;
  max-width: ${VIDEO_EXPANDED_WIDTH}px;
`
